let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("2mt3f"), load("5odbj"), load("9wTW2")]).then(() => parcelRequire('dFOTO'));